export const isPhoneValid = (phone: string | number) => {
  // https://jira.ds-int.cn/browse/BNR-19908
  // eslint-disable-next-line max-len
  return /^(130|131|132|133|134|135|136|137|138|139|145|146|147|150|151|152|153|155|156|157|158|159|166|173|175|176|177|178|180|181|182|183|184|185|186|187|188|189|191|198|199)\d{8}$/.test(`${phone}`)
}
